import { Button } from "@/components/ui/button";
import { ArrowLeft, Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function NotFound() {
	const { t } = useTranslation();
	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-bg-base p-8">
			<div className="relative mb-8">
				<Search className="mx-auto h-16 w-16 text-muted" aria-hidden="true" />
			</div>
			<h1 className="mb-2 text-7xl font-bold text-accent">404</h1>
			<h2 className="mb-3 text-xl font-semibold text-primary">{t("error.notFound")}</h2>
			<p className="mb-8 max-w-md text-center text-secondary">{t("error.notFoundDesc")}</p>
			<Button asChild size="lg">
				<Link to="/">
					<ArrowLeft className="mr-2 h-4 w-4" aria-hidden="true" />
					{t("error.goHome")}
				</Link>
			</Button>
		</div>
	);
}
